import { connect } from 'react-redux'
import {
    resetCollaborativeIndexationCreationInvalidField,
    updateCollaborativeIndexationRepublicanDate,
} from '../../../../../../../redux/collaborativeIndexations/actions'
import {
    getCollaborativeIndexationCreationFields,
    isCollaborativeIndexationCreationInvalidField,
} from '../../../../../../../redux/collaborativeIndexations/selectors'
import Republican from './Republican.jsx'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationRepublicanDate(field, value)),
    resetInvalidField: (field) => dispatch(resetCollaborativeIndexationCreationInvalidField(field)),
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
    isInvalidField: (field) => isCollaborativeIndexationCreationInvalidField(state, field),
})

export const RepublicanContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Republican)
